import React, { ReactElement } from "react";
import { IconProps } from "./types";

export const PayPalLogo = ({
  width = "31",
  height = "32",
}: IconProps): ReactElement => {
  return (
    <div data-testid="PayPal_Logo">
      <svg fill="none" width={width} height={height} viewBox="0 0 48 48">
        <path
          fill="#001C64"
          d="M36.639 12.159c.107-5.565-4.484-9.835-10.797-9.835H12.784a1.278 1.278 0 0 0-1.262 1.078L6.29 36.095a1.038 1.038 0 0 0 1.025 1.2h7.736l-1.209 7.57a1.04 1.04 0 0 0 1.025 1.2h6.302c.304 0 .575-.109.807-.306.23-.198.268-.471.316-.772l1.85-10.884c.047-.3.2-.69.431-.888.231-.198.433-.306.738-.306h3.856c6.183 0 11.428-4.395 12.387-10.507.679-4.338-1.181-8.286-4.915-10.243z"
        />
        <path
          fill="#0070E0"
          d="M16.725 25.238l-1.927 12.218-1.209 7.664a1.038 1.038 0 0 0 1.025 1.199h6.67a1.276 1.276 0 0 0 1.26-1.078l1.758-11.139a1.277 1.277 0 0 1 1.261-1.078h3.926c6.183 0 11.429-4.51 12.388-10.622.68-4.338-1.504-8.286-5.238-10.243-.01.462-.05.923-.121 1.38-.959 6.11-6.206 10.621-12.387 10.621h-6.145a1.278 1.278 0 0 0-1.261 1.079"
        />
        <path
          fill="#003087"
          d="M14.797 37.456h-7.76a1.037 1.037 0 0 1-1.024-1.2l5.232-33.178A1.277 1.277 0 0 1 12.506 2h13.336c6.313 0 10.904 4.594 10.797 10.159-1.571-.824-3.417-1.295-5.439-1.295H20.082a1.277 1.277 0 0 0-1.262 1.078l-2.094 13.296-1.93 12.218z"
        />
      </svg>
    </div>
  );
};
